import Fetch, { V1, V2 } from 'Util/fetcher';

const SET_SHOW_CONTENT = 'SET_SHOW_CONTENT';

export function onDoSetShowContent(payload) {
  return {
    type: SET_SHOW_CONTENT,
    payload,
  };
}

const ON_REQUEST_PROFILE = 'ON_REQUEST_PROFILE';
const ON_REQUEST_PROFILE_FAILURE = 'ON_REQUEST_PROFILE_FAILURE';
const ON_REQUEST_PROFILE_SUCCESS = 'ON_REQUEST_PROFILE_SUCCESS';

function onRequestProfile() {
  return {
    type: ON_REQUEST_PROFILE,
  };
}

function onRequestProfileSuccess(payload) {
  return {
    type: ON_REQUEST_PROFILE_SUCCESS,
    payload,
  };
}

function onRequestProfileFailure(payload) {
  return {
    type: ON_REQUEST_PROFILE_FAILURE,
    payload,
  };
}

export const onDoRequestProfile = () => (dispatch) => {
  dispatch(onRequestProfile());
  Fetch.get(`${V2}stock/profile`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestProfileSuccess(resp.json));
      } else {
        dispatch(onRequestProfileFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestProfileFailure(error.message));
    });
};

const ON_REQUEST_PROFILE_TRADING = 'ON_REQUEST_PROFILE_TRADING';
const ON_REQUEST_PROFILE_TRADING_FAILURE = 'ON_REQUEST_PROFILE_TRADING_FAILURE';
const ON_REQUEST_PROFILE_TRADING_SUCCESS = 'ON_REQUEST_PROFILE_TRADING_SUCCESS';

function onRequestTrading() {
  return {
    type: ON_REQUEST_PROFILE_TRADING,
  };
}

function onRequestTradingSuccess(payload) {
  return {
    type: ON_REQUEST_PROFILE_TRADING_SUCCESS,
    payload,
  };
}

function onRequestTradingFailure(payload) {
  return {
    type: ON_REQUEST_PROFILE_TRADING_FAILURE,
    payload,
  };
}

export const onDoRequestTrading = () => (dispatch) => {
  dispatch(onRequestTrading());
  Fetch.get(`${V1}stock/tradelimit`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestTradingSuccess(resp.json));
      } else {
        dispatch(onRequestTradingFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestTradingFailure(error.message));
    });
};

//= =======================================================================================//
//                    GET API FOR AJAIB CONF FOR THIS PROFILE                              //
//= =======================================================================================//

const ON_REQUEST_PROFILE_CONF = 'ON_REQUEST_PROFILE_CONF';
const ON_REQUEST_PROFILE_CONF_FAILURE = 'ON_REQUEST_PROFILE_CONF_FAILURE';
const ON_REQUEST_PROFILE_CONF_SUCCESS = 'ON_REQUEST_PROFILE_CONF_SUCCESS';

function onRequestProfileConf() {
  return {
    type: ON_REQUEST_PROFILE_CONF,
  };
}

function onRequestProfileConfSuccess(payload) {
  return {
    type: ON_REQUEST_PROFILE_CONF_SUCCESS,
    payload,
  };
}

function onRequestProfileConfFailure(payload) {
  return {
    type: ON_REQUEST_PROFILE_CONF_FAILURE,
    payload,
  };
}

export const onDoRequestProfileConf = () => (dispatch) => {
  dispatch(onRequestProfileConf());
  Fetch.get(`${V2}ajaibconf/home/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestProfileConfSuccess(resp.json));
      } else {
        dispatch(onRequestProfileConfFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestProfileConfFailure(error.message));
    });
};

const ON_REQUEST_HOME_PORTFOLIO = 'ON_REQUEST_HOME_PORTFOLIO';
const ON_REQUEST_HOME_PORTFOLIO_SUCCESS = 'ON_REQUEST_HOME_PORTFOLIO_SUCCESS';
const ON_REQUEST_HOME_PORTFOLIO_FAILURE = 'ON_REQUEST_HOME_PORTFOLIO_FAILURE';

function onRequestHomePortfolio() {
  return {
    type: ON_REQUEST_HOME_PORTFOLIO,
  };
}

function onRequestHomePortfolioSuccess(payload) {
  return {
    type: ON_REQUEST_HOME_PORTFOLIO_SUCCESS,
    payload,
  };
}

function onRequestHomePortfolioFailure(payload) {
  return {
    type: ON_REQUEST_HOME_PORTFOLIO_FAILURE,
    payload,
  };
}

export const onDoRequestHomePortfolio = () => (dispatch) => {
  dispatch(onRequestHomePortfolio());
  Fetch.get(`${V2}home/portfolio/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestHomePortfolioSuccess(resp.json));
      } else {
        dispatch(onRequestHomePortfolioFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestHomePortfolioFailure(error.message));
    });
};

const ON_REQUEST_HOME_PORTFOLIO_STOCK = 'ON_REQUEST_HOME_PORTFOLIO_STOCK';
const ON_REQUEST_HOME_PORTFOLIO_STOCK_SUCCESS = 'ON_REQUEST_HOME_PORTFOLIO_STOCK_SUCCESS';
const ON_REQUEST_HOME_PORTFOLIO_STOCK_FAILURE = 'ON_REQUEST_HOME_PORTFOLIO_STOCK_FAILURE';

function onRequestHomePortfolioStock() {
  return {
    type: ON_REQUEST_HOME_PORTFOLIO_STOCK,
  };
}

function onRequestHomePortfolioStockSuccess(payload) {
  return {
    type: ON_REQUEST_HOME_PORTFOLIO_STOCK_SUCCESS,
    payload,
  };
}

function onRequestHomePortfolioStockFailure(payload) {
  return {
    type: ON_REQUEST_HOME_PORTFOLIO_STOCK_FAILURE,
    payload,
  };
}

export const onDoRequestHomePortfolioStock = () => (dispatch) => {
  dispatch(onRequestHomePortfolioStock());
  Fetch.get(`${V1}home/portfolio/stock`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestHomePortfolioStockSuccess(resp.json));
      } else {
        dispatch(onRequestHomePortfolioStockFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestHomePortfolioStockFailure(error.message));
    });
};

const ON_REQUEST_HOME_PORTFOLIO_BONUS = 'ON_REQUEST_HOME_PORTFOLIO_BONUS';
const ON_REQUEST_HOME_PORTFOLIO_BONUS_SUCCESS = 'ON_REQUEST_HOME_PORTFOLIO_BONUS_SUCCESS';
const ON_REQUEST_HOME_PORTFOLIO_BONUS_FAILURE = 'ON_REQUEST_HOME_PORTFOLIO_BONUS_FAILURE';

function onRequestHomePortfolioBonus() {
  return {
    type: ON_REQUEST_HOME_PORTFOLIO_BONUS,
  };
}

function onRequestHomePortfolioBonusSuccess(payload) {
  return {
    type: ON_REQUEST_HOME_PORTFOLIO_BONUS_SUCCESS,
    payload,
  };
}

function onRequestHomePortfolioBonusFailure(payload) {
  return {
    type: ON_REQUEST_HOME_PORTFOLIO_BONUS_FAILURE,
    payload,
  };
}

export const onDoRequestHomePortfolioBonus = () => (dispatch) => {
  dispatch(onRequestHomePortfolioBonus());
  Fetch.get(`${V1}home/portfolio/bonus`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestHomePortfolioBonusSuccess(resp.json));
      } else {
        dispatch(onRequestHomePortfolioBonusFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestHomePortfolioBonusFailure(error.message));
    });
};

const ON_REQUEST_HOME_PORTFOLIO_MF = 'ON_REQUEST_HOME_PORTFOLIO_MF';
const ON_REQUEST_HOME_PORTFOLIO_MF_SUCCESS = 'ON_REQUEST_HOME_PORTFOLIO_MF_SUCCESS';
const ON_REQUEST_HOME_PORTFOLIO_MF_FAILURE = 'ON_REQUEST_HOME_PORTFOLIO_MF_FAILURE';

function onRequestHomePortfolioMf() {
  return {
    type: ON_REQUEST_HOME_PORTFOLIO_MF,
  };
}

function onRequestHomePortfolioMfSuccess(payload) {
  return {
    type: ON_REQUEST_HOME_PORTFOLIO_MF_SUCCESS,
    payload,
  };
}

function onRequestHomePortfolioMfFailure(payload) {
  return {
    type: ON_REQUEST_HOME_PORTFOLIO_MF_FAILURE,
    payload,
  };
}

export const onDoRequestHomePortfolioMf = () => (dispatch) => {
  dispatch(onRequestHomePortfolioMf());
  Fetch.get(`${V1}home/portfolio/mf`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestHomePortfolioMfSuccess(resp.json));
      } else {
        dispatch(onRequestHomePortfolioMfFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestHomePortfolioMfFailure(error.message));
    });
};

const ON_REQUEST_HOME_PORTFOLIO_FINANCIAL_PLAN = 'ON_REQUEST_HOME_PORTFOLIO_FINANCIAL_PLAN';
const ON_REQUEST_HOME_PORTFOLIO_FINANCIAL_PLAN_SUCCESS =
  'ON_REQUEST_HOME_PORTFOLIO_FINANCIAL_PLAN_SUCCESS';
const ON_REQUEST_HOME_PORTFOLIO_FINANCIAL_PLAN_FAILURE =
  'ON_REQUEST_HOME_PORTFOLIO_FINANCIAL_PLAN_FAILURE';

function onRequestHomePortfolioFinancialPlan() {
  return {
    type: ON_REQUEST_HOME_PORTFOLIO_FINANCIAL_PLAN,
  };
}

function onRequestHomePortfolioFinancialPlanSuccess(payload) {
  return {
    type: ON_REQUEST_HOME_PORTFOLIO_FINANCIAL_PLAN_SUCCESS,
    payload,
  };
}

function onRequestHomePortfolioFinancialPlanFailure(payload) {
  return {
    type: ON_REQUEST_HOME_PORTFOLIO_FINANCIAL_PLAN_FAILURE,
    payload,
  };
}

export const onDoRequestHomePortfolioFinancialPlan = () => (dispatch) => {
  dispatch(onRequestHomePortfolioFinancialPlan());
  Fetch.get(`${V1}home/portfolio/financial-plan`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestHomePortfolioFinancialPlanSuccess(resp.json));
      } else {
        dispatch(onRequestHomePortfolioFinancialPlanFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestHomePortfolioFinancialPlanFailure(error.message));
    });
};

//= ============================//
//         UPLOAD PHOTO        //
//= ============================//

const ON_REQUEST_UPDATE_PHOTO = 'ON_REQUEST_UPDATE_PHOTO';
const ON_REQUEST_UPDATE_PHOTO_SUCCESS = 'ON_REQUEST_UPDATE_PHOTO_SUCCESS';
const ON_REQUEST_UPDATE_PHOTO_FAILURE = 'ON_REQUEST_UPDATE_PHOTO_FAILURE';
const RESET_UPDATE_PHOTO = 'RESET_UPDATE_PHOTO';

function onRequestUpdatePhoto() {
  return {
    type: ON_REQUEST_UPDATE_PHOTO,
  };
}

function onRequestUpdatePhotoSuccess() {
  return {
    type: ON_REQUEST_UPDATE_PHOTO_SUCCESS,
  };
}

function onRequestUpdatePhotoFailure(payload) {
  return {
    type: ON_REQUEST_UPDATE_PHOTO_FAILURE,
    payload,
  };
}

export const onDoRequestUpdatePhoto = (payload) => (dispatch) => {
  dispatch(onRequestUpdatePhoto());
  Fetch.post(`${V1}users/me/user-photo/`, payload)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestUpdatePhotoSuccess());
      } else {
        dispatch(onRequestUpdatePhotoFailure());
      }
    })
    .catch((error) => {
      dispatch(onRequestUpdatePhotoFailure(error.message));
    });
};

function resetUpdatePhoto() {
  return {
    type: RESET_UPDATE_PHOTO,
  };
}

export const onDoResetUpdatePhoto = () => (dispatch) => {
  dispatch(resetUpdatePhoto());
};

//= ============================//
//         UPLOAD PHOTO        //
//= ============================//

const ON_REQUEST_RESET_PASSWORD = 'ON_REQUEST_RESET_PASSWORD';
const ON_REQUEST_RESET_PASSWORD_SUCCESS = 'ON_REQUEST_RESET_PASSWORD_SUCCESS';
const ON_REQUEST_RESET_PASSWORD_FAILURE = 'ON_REQUEST_RESET_PASSWORD_FAILURE';

function onRequestResetPassword() {
  return {
    type: ON_REQUEST_RESET_PASSWORD,
  };
}

function onRequestResetPasswordSuccess(payload) {
  return {
    type: ON_REQUEST_RESET_PASSWORD_SUCCESS,
    payload,
  };
}

function onRequestResetPasswordFailure(payload) {
  return {
    type: ON_REQUEST_RESET_PASSWORD_FAILURE,
    payload,
  };
}

export const onDoRequestResetPassword = (payload) => (dispatch) => {
  dispatch(onRequestResetPassword());
  Fetch.post(`${V2}password/reset/`, payload)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestResetPasswordSuccess(resp.json));
      } else {
        dispatch(onRequestResetPasswordFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestResetPasswordFailure(error.message));
    });
};

const ON_REQUEST_MEMBERSHIP = 'ON_REQUEST_MEMBERSHIP';
const ON_REQUEST_MEMBERSHIP_FAILURE = 'ON_REQUEST_MEMBERSHIP_FAILURE';
const ON_REQUEST_MEMBERSHIP_SUCCESS = 'ON_REQUEST_MEMBERSHIP_SUCCESS';

function onRequestMembership() {
  return {
    type: ON_REQUEST_MEMBERSHIP,
  };
}

function onRequestMembershipSuccess(payload) {
  return {
    type: ON_REQUEST_MEMBERSHIP_SUCCESS,
    payload,
  };
}

function onRequestMembershipFailure(payload) {
  return {
    type: ON_REQUEST_MEMBERSHIP_FAILURE,
    payload,
  };
}

export const onDoRequestMembership = () => (dispatch) => {
  dispatch(onRequestMembership());
  Fetch.get(`${V1}users/membership/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestMembershipSuccess(resp.json));
      } else {
        dispatch(onRequestMembershipFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestMembershipFailure(error.message));
    });
};

const ON_CLEAR = 'ON_CLEAR';

function onClear() {
  return {
    type: ON_CLEAR,
  };
}
export const onDoClear = () => (dispatch) => {
  dispatch(onClear());
};

const INITIAL_STATE = {
  showContent: 'Personal Info',

  profileLoading: false,
  profileData: null,
  profileError: null,

  profileConfLoading: false,
  profileConfData: null,
  profileConfError: null,

  homePortfolioLoading: false,
  homePortfolioData: null,
  homePortfolioError: null,

  homePortfolioStockLoading: false,
  homePortfolioStockData: null,
  homePortfolioStockError: null,

  homePortfolioBonusLoading: false,
  homePortfolioBonusData: null,
  homePortfolioBonusError: null,

  homePortfolioMfLoading: false,
  homePortfolioMfData: null,
  homePortfolioMfError: null,

  homePortfolioFinancialPlanLoading: false,
  homePortfolioFinancialPlanData: null,
  homePortfolioFinancialPlanError: null,

  profileTradeData: null,
  profileTradeLoading: false,
  profileTradeError: null,

  membershipLoading: false,
  membershipData: null,
  membershipError: null,

  uploadPhotoLoading: false,
  updatePhotoError: null,
  updatePhotoSuccess: null,

  resetPasswordLoading: false,
  resetPasswordError: null,
  resetPasswordSuccess: null,
};

const profile = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_SHOW_CONTENT:
      return {
        ...state,
        showContent: action.payload,
      };
    case ON_REQUEST_UPDATE_PHOTO:
      return {
        ...state,
        updatePhotoLoading: true,
        updatePhotoError: null,
        updatePhotoSuccess: null,
      };
    case ON_REQUEST_UPDATE_PHOTO_SUCCESS:
      return {
        ...state,
        updatePhotoLoading: false,
        updatePhotoSuccess: true,
        updatePhotoError: null,
      };
    case ON_REQUEST_UPDATE_PHOTO_FAILURE:
      return {
        ...state,
        updatePhotoLoading: false,
        updatePhotoError: action.payload,
        updatePhotoSuccess: null,
      };
    case RESET_UPDATE_PHOTO:
      return {
        ...state,
        updatePhotoLoading: false,
        updatePhotoError: null,
        updatePhotoSuccess: null,
      };
    case ON_REQUEST_PROFILE:
      return {
        ...state,
        profileLoading: true,
        profileData: null,
        profileError: null,
      };
    case ON_REQUEST_PROFILE_SUCCESS:
      return {
        ...state,
        profileLoading: false,
        profileData: action.payload,
        profileError: null,
      };
    case ON_REQUEST_PROFILE_FAILURE:
      return {
        ...state,
        profileLoading: false,
        profileData: null,
        profileError: action.payload,
      };
    case ON_REQUEST_MEMBERSHIP:
      return {
        ...state,
        membershipLoading: true,
        membershipData: null,
        membershipError: null,
      };
    case ON_REQUEST_MEMBERSHIP_SUCCESS:
      return {
        ...state,
        membershipLoading: false,
        membershipData: action.payload,
        membershipError: null,
      };
    case ON_REQUEST_MEMBERSHIP_FAILURE:
      return {
        ...state,
        membershipLoading: false,
        membershipData: null,
        membershipError: action.payload,
      };
    case ON_REQUEST_PROFILE_CONF:
      return {
        ...state,
        profileConfLoading: true,
        profileConfData: null,
        profileConfError: null,
      };
    case ON_REQUEST_PROFILE_CONF_SUCCESS:
      return {
        ...state,
        profileConfLoading: false,
        profileConfData: action.payload,
        profileConfError: null,
      };
    case ON_REQUEST_PROFILE_CONF_FAILURE:
      return {
        ...state,
        profileConfLoading: false,
        profileConfData: null,
        profileConfError: action.payload,
      };
    case ON_REQUEST_HOME_PORTFOLIO:
      return {
        ...state,
        homePortfolioLoading: true,
        homePortfolioData: null,
        homePortfolioError: null,
      };
    case ON_REQUEST_HOME_PORTFOLIO_SUCCESS:
      return {
        ...state,
        homePortfolioLoading: false,
        homePortfolioData: action.payload,
        homePortfolioError: null,
      };
    case ON_REQUEST_HOME_PORTFOLIO_FAILURE:
      return {
        ...state,
        homePortfolioLoading: false,
        homePortfolioData: null,
        homePortfolioError: action.payload,
      };
    case ON_REQUEST_HOME_PORTFOLIO_STOCK:
      return {
        ...state,
        homePortfolioStockLoading: true,
        homePortfolioStockData: null,
        homePortfolioStockError: null,
      };
    case ON_REQUEST_HOME_PORTFOLIO_STOCK_SUCCESS:
      return {
        ...state,
        homePortfolioStockLoading: false,
        homePortfolioStockData: action.payload,
        homePortfolioStockError: null,
      };
    case ON_REQUEST_HOME_PORTFOLIO_STOCK_FAILURE:
      return {
        ...state,
        homePortfolioStockLoading: false,
        homePortfolioStockData: null,
        homePortfolioStockError: action.payload,
      };
    case ON_REQUEST_HOME_PORTFOLIO_BONUS:
      return {
        ...state,
        homePortfolioBonusLoading: true,
        homePortfolioBonusData: null,
        homePortfolioBonusError: null,
      };
    case ON_REQUEST_HOME_PORTFOLIO_BONUS_SUCCESS:
      return {
        ...state,
        homePortfolioBonusLoading: false,
        homePortfolioBonusData: action.payload,
        homePortfolioBonusError: null,
      };
    case ON_REQUEST_HOME_PORTFOLIO_BONUS_FAILURE:
      return {
        ...state,
        homePortfolioBonusLoading: false,
        homePortfolioBonusData: null,
        homePortfolioBonusError: action.payload,
      };
    case ON_REQUEST_HOME_PORTFOLIO_MF:
      return {
        ...state,
        homePortfolioMfLoading: true,
        homePortfolioMfData: null,
        homePortfolioMfError: null,
      };
    case ON_REQUEST_HOME_PORTFOLIO_MF_SUCCESS:
      return {
        ...state,
        homePortfolioMfLoading: false,
        homePortfolioMfData: action.payload,
        homePortfolioMfError: null,
      };
    case ON_REQUEST_HOME_PORTFOLIO_MF_FAILURE:
      return {
        ...state,
        homePortfolioMfLoading: false,
        homePortfolioMfData: null,
        homePortfolioMfError: action.payload,
      };
    case ON_REQUEST_HOME_PORTFOLIO_FINANCIAL_PLAN:
      return {
        ...state,
        homePortfolioFinancialPlanLoading: true,
        homePortfolioFinancialPlanData: null,
        homePortfolioFinancialPlanError: null,
      };
    case ON_REQUEST_HOME_PORTFOLIO_FINANCIAL_PLAN_SUCCESS:
      return {
        ...state,
        homePortfolioFinancialPlanLoading: false,
        homePortfolioFinancialPlanData: action.payload,
        homePortfolioFinancialPlanError: null,
      };
    case ON_REQUEST_HOME_PORTFOLIO_FINANCIAL_PLAN_FAILURE:
      return {
        ...state,
        homePortfolioFinancialPlanLoading: false,
        homePortfolioFinancialPlanData: null,
        homePortfolioFinancialPlanError: action.payload,
      };
    case ON_REQUEST_PROFILE_TRADING:
      return {
        ...state,
        profileTradeLoading: true,
        profileTradeData: null,
        profileTradeError: null,
      };
    case ON_REQUEST_PROFILE_TRADING_SUCCESS:
      return {
        ...state,
        profileTradeLoading: false,
        profileTradeData: action.payload,
        profileTradeError: null,
      };
    case ON_REQUEST_PROFILE_TRADING_FAILURE:
      return {
        ...state,
        profileTradeLoading: false,
        profileTradeData: null,
        profileTradeError: action.payload,
      };
    case ON_REQUEST_RESET_PASSWORD:
      return {
        ...state,
        resetPasswordLoading: true,
        resetPasswordError: null,
      };
    case ON_REQUEST_RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPasswordLoading: false,
        resetPasswordError: null,
        resetPasswordSuccess: action.payload,
      };
    case ON_REQUEST_RESET_PASSWORD_FAILURE:
      return {
        ...state,
        resetPasswordLoading: false,
        resetPasswordSuccess: null,
        resetPasswordError: action.payload,
      };

    case ON_CLEAR:
      return {
        profileLoading: false,
        profileData: null,
        profileError: null,

        profileConfLoading: false,
        profileConfData: null,
        profileConfError: null,

        profileTradeData: null,
        profileTradeLoading: false,
        profileTradeError: null,

        uploadPhotoLoading: false,
        updatePhotoError: null,
        updatePhotoSuccess: null,

        resetPasswordLoading: false,
        resetPasswordError: null,
        resetPasswordSuccess: null,
      };
    default:
      return state;
  }
};

export default profile;
